export default "https://storage.googleapis.com/prepweb-prod/dist/c0a6ef364aca4f3ddfca4ee52952dde4.svg";